import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 900px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    right: -100px;
    bottom: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, var(--accent-glow) 0%, transparent 60%);
    opacity: 0.2;
    pointer-events: none;
  }

  @media(max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
`;

const Content = styled.div`
  flex: 1;
  padding-right: 40px;
  
  @media(max-width: 768px) {
    padding-right: 0;
  }

  h3 { margin: 0 0 15px 0; color: var(--text-primary); font-size: 28px; }
  p { margin: 0; color: var(--text-secondary); font-size: 16px; line-height: 1.5; }
`;

const Actions = styled.div`
  display: flex;
  gap: 15px;

  @media(max-width: 500px) {
    flex-direction: column;
    width: 100%;
  }
`;

const PrimeButton = styled.button`
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 15px 30px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--accent-glow);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  
  svg { width: 20px; height: 20px; }
`;

const GhostButton = styled.button`
  background: var(--glass-2);
  color: var(--text-primary);
  border: 1px solid var(--glass-border);
  border-radius: 8px;
  padding: 15px 30px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    background: rgba(255,255,255,0.1);
    border-color: var(--accent);
  }
`;

const ContactTeaserWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Content>
        <h3>{node.content?.title || 'Brauchen Sie Hilfe bei der Auswahl?'}</h3>
        <p>{node.content?.desc || 'Unsere Experten stehen Ihnen rund um die Uhr zur Verfügung. Egal ob Neuvertrag, Vertragsverlängerung oder technische Fragen – wir helfen gerne!'}</p>
      </Content>
      <Actions>
        <PrimeButton className="tef-bubbles">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path></svg>
          Live Chat
        </PrimeButton>
        <GhostButton className="tef-bubbles">
          Rückruf anfordern
        </GhostButton>
      </Actions>
    </Wrapper>
  );
};

registry.register('contact_teaser', {
  label: 'Kontakt Teaser',
  icon: '📞',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: ContactTeaserWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Inhalt', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.desc', label:'Beschreibung', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
